import React, { useEffect, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { useHistory } from "react-router-dom";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  FormInput,
  HospitalDropDown,
  Icon,
  MoreOptions,
  PreviewCard,
  TooltipComponent,
} from "../../../components/Component";
import JobList from "./JobList";
import { JobStatusType } from "../../../utils";
import { toCapitalize } from "../../../utils/Functions";
import { ButtonGroup } from "reactstrap";
import { GradeTypeDropDownWithoutCarer } from "../../../components/dropdowns/GradeTypeDropDown";
import SendEmailModal from "../invoices/invoiceEmail/SendEmailModal";
import HospitalHomeCareDropDown from "../../../components/dropdowns/HospitalHomeCareDropDown";
import { CarerTypeDropDown } from "../../../components/dropdowns/CarerTypeDropDown";
import { UserActionType, UserPermissionType, isAllowToAccess } from "../../../services/permission/permission";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  ClientTypeDropdownOptions,
  parseUrlParams,
  removeWhitespace,
  updateHash,
  useCarerTypeData,
  useClientData,
  useGradeData,
} from "../../../utils/Utils";

const Job = () => {
  const [status, setStatus] = useState({ value: JobStatusType.open });
  const [clientType, setClientType] = useState();
  const [carerType, setCarerType] = useState();
  const [searchText, setSearchText] = useState();
  const [client, setClient] = useState();
  const [grade, setGrade] = useState();
  const [modal, setModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [activeButton, setActiveButton] = useState(0); // 0 corresponds to the index of the first button
  const [sm, updateSm] = useState(false);
  const [totalItems, setTotalItems] = useState(); // the lifted state
  const [currentPage, setCurrentPage] = useState();
  const history = useHistory();
  const location = useLocation();
  const statisticsStatus = location?.state?.status;
  const updatedGradeData = useGradeData();
  const updatedClientData = useClientData();
  const updatedCarerTypeData = useCarerTypeData();
  const params = parseUrlParams();

  useEffect(() => {
    if (statisticsStatus && location?.state?.isJobListMove) {
      setActiveButton(statusValues.findIndex((valueItem) => valueItem === statisticsStatus));
      setStatus({ value: statisticsStatus });
    }
  }, [location?.state?.isJobListMove, statisticsStatus]);

  useEffect(() => {
    if (params.page) {
      setCurrentPage(parseInt(params.page, 10));
    } else {
      setCurrentPage(1);
    }

    if (params.clientType) {
      const selectedClientType = ClientTypeDropdownOptions.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.clientType)
      );
      if (selectedClientType && selectedClientType.value !== clientType?.value) {
        setClientType(selectedClientType);
      }
    }

    if (params.carerType) {
      const selectedCarerType = updatedCarerTypeData.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.carerType)
      );
      if (selectedCarerType && selectedCarerType.value !== carerType?.value) {
        setCarerType(selectedCarerType);
      }
    }

    if (params.grade) {
      const matchedGrade = updatedGradeData.find(
        (item) => removeWhitespace(item.value) === removeWhitespace(params.grade)
      );
      if (matchedGrade && matchedGrade.value !== grade?.value) {
        setGrade(matchedGrade);
      }
    }

    if (params.client) {
      const selectedClient = updatedClientData.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.client)
      );
      if (selectedClient && selectedClient.value !== client?.value) {
        setClient(selectedClient);
      }
    }

    if (params.status) {
      const selectedStatus = statusValues.find(
        (option) => removeWhitespace(option) === removeWhitespace(params.status)
      );

      if (selectedStatus && selectedStatus !== status?.value) {
        handleButtonClick(selectedStatus);
      }
    }

    if (params.search) {
      const searchQuery = decodeURIComponent(params.search);
      setSearchText(searchQuery);
    }
  }, [location]);

  useEffect(() => {
    if (!currentPage) return;
    updateQueryParams({ page: currentPage });
  }, [currentPage]);

  const val = {
    ...JobStatusType,
    all: "ALL",
  };
  const statusValues = Object.values(val);

  const isRowSelected = selectedRows.length > 0;
  const onAddClick = () => {
    history.push(`${process.env.PUBLIC_URL}/add-job`);
  };

  const onEmail = (selectedRows) => {
    setModal(true);
  };

  const handleButtonClick = (item) => {
    const newValue = item === "ALL" ? "ALL" : item;
    setActiveButton(statusValues.findIndex((valueItem) => valueItem === item));
    setStatus({ value: newValue });
    updateQueryParams({ status: newValue });
  };

  const getTotalItem = (totalItem) => {
    // the callback. Use a better name
    setTotalItems(totalItem);
  };

  const updateQueryParams = (updates) => {
    if (
      updates.status !== undefined &&
      params.status !== undefined &&
      removeWhitespace(updates.status) === removeWhitespace(params.status)
    )
      return;
    updateHash({
      page: currentPage,
      grade: grade?.value,
      status: status?.value,
      clientType: clientType?.value,
      carerType: carerType?.value,
      client: client?.value,
      searchText: searchText,
      pathname: location.pathname,
      ...updates,
    });
  };

  const onGradeChange = (grade) => {
    setGrade(grade);
    updateQueryParams({ grade: grade?.value });
  };

  const onClientChange = (client) => {
    setClient(client);
    updateQueryParams({ client: client?.value });
  };

  const onHospitalTypeChange = (clientType) => {
    setClientType(clientType);
    updateQueryParams({ clientType: clientType?.value });
  };

  const onCarerTypeChange = (carerType) => {
    setCarerType(carerType);
    updateQueryParams({ carerType: carerType?.value });
  };

  const onSearchChange = (searchText) => {
    setSearchText(searchText);
    updateQueryParams({ searchText: searchText });
  };

  return (
    <React.Fragment>
      <Head title="Job" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <div className="d-flex align-items-center">
                <span>
                  <BlockTitle page className={"mb-0"}>
                    Jobs
                  </BlockTitle>
                  <BlockDes>{totalItems} Jobs</BlockDes>
                </span>
              </div>
            </BlockHeadContent>

            <BlockHeadContent className="ms-auto">
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="more-v"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-2 d-flex flex-wrap justify-content-end">
                    <li>
                      <FormInput
                        inputClass={"padding-important"}
                        isShowLabel={false}
                        value={searchText ?? ""}
                        placeholder="Request ID,Hospital, Ward"
                        onTextChange={onSearchChange}
                      />
                    </li>
                    <li>
                      <ButtonGroup>
                        {statusValues
                          ?.filter((item) => item !== "CANCELLED")
                          .map((item) => (
                              <Button
                                key={item}
                                className={`btn-dim btn-white border-right border
                             ${activeButton === statusValues?.findIndex((valueItem) => valueItem === item)
                                    ? "bg-purple btn-lighter text-white"
                                    : "bg-white text-gray"
                                  }`}
                                onClick={() => handleButtonClick(item)}
                              >
                                {toCapitalize(item)}
                              </Button>
                          ))}
                      </ButtonGroup>
                    </li>
                    <li>
                      <HospitalDropDown
                        isClearable
                        value={client}
                        className="w-300px"
                        onSelect={(selectedClient) => {
                          onClientChange(selectedClient);
                        }}
                      />
                    </li>
                    <li>
                      <HospitalHomeCareDropDown
                        value={clientType}
                        placeholder={"Client Type"}
                        className="w-125px"
                        onSelect={(e) => {
                          onHospitalTypeChange(e);
                        }}
                      />
                    </li>
                    <li>
                      <CarerTypeDropDown
                        value={carerType}
                        placeholder={"Carer Type"}
                        className="w-150px"
                        isClearable
                        onSelect={(selectedCarerType) => {
                          onCarerTypeChange(selectedCarerType);
                        }}
                      />
                    </li>
                    <li>
                      <GradeTypeDropDownWithoutCarer
                        value={grade}
                        isClearable
                        isShowAll
                        className="w-250px"
                        placeholder={"Grade Type"}
                        selectedId={grade?.id}
                        onSelect={(selectedGrade) => {
                          onGradeChange(selectedGrade);
                        }}
                      />
                    </li>
                    {/* <li>
                      <ImportExportButton addButton title={"Add"} onClick={() => onAddClick()} iconName={"plus"} />
                    </li> */}
                    {isAllowToAccess(UserPermissionType.job, UserActionType.add) && (
                      <li>
                        <Button href={""} className="btn-icon bg-purple border-0" onClick={() => onAddClick()}>
                          <TooltipComponent icon={"plus"} id={"addjob"} text={"Add"} iconClass={"text-white"} />
                        </Button>
                      </li>
                    )}
                    {isRowSelected && (
                      <li>
                        <span>
                          <MoreOptions
                            className="text-bg-light"
                            options={[
                              {
                                icon: "emails",
                                text: "Email",
                                action: () => {
                                  onEmail(selectedRows);
                                },
                              },
                              {
                                icon: "chat",
                                text: "Sms",
                                action: () => {
                                  // onSms(row);
                                },
                              },
                            ]}
                          />
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard className={"bg-transparent job-list-table"}>
            <div className="tableDatalistingText m-n4">
              <JobList
                clientId={client?.id}
                page={currentPage}
                setPage={setCurrentPage}
                isPage={true}
                isPageForURL={true}
                searchText={searchText}
                gradeId={grade?.id}
                status={status}
                carerType={carerType}
                clientType={clientType}
                selectableRows={true}
                onRowSelectionChange={(rows) => setSelectedRows(rows)}
                getTotalItem={getTotalItem}
              />
            </div>
          </PreviewCard>
        </Block>
        <SendEmailModal
          visible={modal}
          item={selectedRows}
          onClosed={() => {
            setModal(false);
          }}
          onSaved={() => {
            //  loadBranch();
          }}
        />
      </Content>
    </React.Fragment>
  );
};

export default Job;
